/*
 * @Date: 2024-08-15 14:37:54
 * @LastEditors: Mipawn dongzhan@mipawn.com
 * @LastEditTime: 2024-08-16 15:24:58
 * @Author: Mipawn
 * @Description: 连续充值弹窗
 */

import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { implog as impLog } from '@/api/implog';
import showNiceModal from '@/components/nice-modal';
import { modalStore } from '@/stores/modal';
import { resolveImgPath } from '@/utils/img';

const ContinueRechargeModal = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const goContinueRecharge = () => {
    impLog('continue_recharge_modal_click');
    if (pathname === '/game') {
      modalStore.closeTaskChain();
    }
    navigate('/continue-recharge');
  };

  useEffect(() => {
    impLog('continue_recharge_modal_show');
  }, []);
  return (
    <div style={{ fontSize: 0 }} onClick={goContinueRecharge}>
      <img src={resolveImgPath('modal/continue_recharge.webp')} style={{ width: '100% ' }} />
    </div>
  );
};

export const show = props => {
  return showNiceModal({
    children: <ContinueRechargeModal />,
    width: '6rem',
    top: '15vh',
    maskClosable: true,
    ...(props || {})
  });
};

export default ContinueRechargeModal;
